/* Add to cart from collections page */
/* Collection page custom add to cart */

(function() {
  var TOAST_VISIBLE_CLASS = 'custom-cart-toast-visible';
  var THEME_PROGRESS_CLASS = 'custom-cart-add-in-progress';
  var CAROUSEL_POINTER_FOCUS_CLASS = 'is-carousel-pointer-focus-return';
  var cartRefreshPromise = null;
  var cartClearPromise = null;
  var activeCartAdds = 0;
  var cartAddIdleCallbacks = [];
  var lastInputWasKeyboard = false;
  var cartDrawerCarouselReturnFocusElement = null;

  function themeRoute(name, fallback) {
    return window.theme && window.theme.routes && window.theme.routes[name]
      ? window.theme.routes[name]
      : fallback;
  }

  function themeAjaxRoute(name, fallback) {
    var route = themeRoute(name, fallback);
    return /\.js(?:[?#]|$)/.test(route) ? route : route + '.js';
  }

  function clearFormError(form) {
    var error = form && form.querySelector('[data-custom-cart-error]');
    if (error) error.remove();
  }

  function showFormError(form, message) {
    if (!form) return;
    clearFormError(form);

    var error = document.createElement('p');
    error.className = 'errors qty-error';
    error.setAttribute('data-custom-cart-error', '');
    error.setAttribute('role', 'alert');
    error.textContent = message || 'We could not add this item. Please try again.';
    form.appendChild(error);
  }

  function clearThemeCartState() {
    document.documentElement.classList.remove(THEME_PROGRESS_CLASS);
    document.body.classList.remove(THEME_PROGRESS_CLASS);
  }

  function getQuantity(form) {
    var input = form.querySelector('input[name="quantity"], [data-smart-search-quantity]');
    var value = input ? parseInt(input.value, 10) : 1;

    return value > 0 ? value : 1;
  }

  function resizeQuantityInput(input) {
    if (!input || !input.matches) return;

    var isCollectionGrid = input.matches('body.template-collection .custom-product-grid .custom-product-card-order .custom-product-qty.custom-product-qty--after-add > input[name="quantity"], body.template-search .custom-product-grid .custom-product-card-order .custom-product-qty.custom-product-qty--after-add > input[name="quantity"]');
    var isCollectionList = input.matches('body.template-collection .custom-product-list-item .custom-product-card-order .custom-product-qty.custom-product-qty--after-add > input[name="quantity"], body.template-search .custom-product-list-item .custom-product-card-order .custom-product-qty.custom-product-qty--after-add > input[name="quantity"]');
    var isCart = input.matches('#ajaxifyDrawer .cart-sidebar-products .ajaxifyCart--num, #ajaxifyDrawer .cart-sidebar-products .js--num, body.template-cart .cart-sidebar-products input[name="updates[]"]');

    if (!isCollectionGrid && !isCollectionList && !isCart) return;

    var maxScalingDigits = 5;
    var digits = Math.max(1, Math.min(maxScalingDigits, String(input.value || '1').replace(/\D/g, '').length));
    var extraWidth = Math.max(0, digits - 2) * 7;

    if (isCart) {
      var cartWidthValue = (75 + extraWidth) + 'px';
      var cartSelector = input.closest('.ajaxifyCart--qty, .js-qty');

      input.style.setProperty('width', cartWidthValue, 'important');
      if (cartSelector) {
        cartSelector.style.setProperty('width', cartWidthValue, 'important');
        cartSelector.style.setProperty('min-width', cartWidthValue, 'important');
        cartSelector.style.setProperty('max-width', cartWidthValue, 'important');
      }
      return;
    }

    var selector = input.closest('.custom-product-qty--after-add');
    var popover = input.closest('.custom-quantity-popover');

    if (isCollectionGrid) {
      input.closest('.custom-product-card-order').style.setProperty('--collection-grid-quantity-extra-width', extraWidth + 'px');
      return;
    }

    /* Collection inline qty hides +/-; size the field only so it touches Add. */
    var collectionWidth = (28 + extraWidth) + 'px';
    input.style.setProperty('width', '100%', 'important');
    if (selector) {
      selector.style.setProperty('width', collectionWidth, 'important');
      selector.style.setProperty('min-width', collectionWidth, 'important');
      selector.style.setProperty('max-width', collectionWidth, 'important');
      selector.style.setProperty('grid-template-columns', 'none', 'important');
    }
    if (popover) popover.style.setProperty('width', collectionWidth, 'important');
  }

  function resizeAllQuantityInputs(root) {
    var scope = root || document;
    if (scope.matches && scope.matches('input')) resizeQuantityInput(scope);
    scope.querySelectorAll('.custom-product-qty.custom-product-qty--after-add > input[name="quantity"], #ajaxifyDrawer .cart-sidebar-products .ajaxifyCart--num, #ajaxifyDrawer .cart-sidebar-products .js--num, body.template-cart .cart-sidebar-products input[name="updates[]"]').forEach(resizeQuantityInput);
  }

  resizeAllQuantityInputs(document);
  document.addEventListener('shopify:section:load', function(event) {
    resizeAllQuantityInputs(event.target);
  });
  document.addEventListener('input', function(event) {
    resizeQuantityInput(event.target);
  });
  document.addEventListener('click', function(event) {
    var adjuster = event.target.closest('#ajaxifyDrawer .ajaxifyCart--qty-adjuster, #ajaxifyDrawer .js--qty-adjuster');
    if (!adjuster) return;

    setTimeout(function() {
      resizeQuantityInput(adjuster.parentElement.querySelector('.ajaxifyCart--num, .js--num'));
    }, 0);
  });

  new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === 1) resizeAllQuantityInputs(node);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });

  function loadProductCardHoverImage(card) {
    if (!card) return;
    var image = card.querySelector('.custom-product-image-hover[data-hover-src]');
    if (!image) return;
    image.src = image.getAttribute('data-hover-src');
    image.removeAttribute('data-hover-src');
  }

  document.addEventListener('pointerover', function(event) {
    if (event.pointerType === 'touch') return;
    var card = event.target.closest('[data-product-card]');
    if (!card || (event.relatedTarget && card.contains(event.relatedTarget))) return;
    loadProductCardHoverImage(card);
  });

  document.addEventListener('focusin', function(event) {
    loadProductCardHoverImage(event.target.closest('[data-product-card]'));
  });

  function updateCartCount(count) {
    document.querySelectorAll('.cart-count').forEach(function(countEl) {
      countEl.textContent = count;

      if (count > 0) {
        countEl.classList.remove('hidden-count', 'hidden', 'hide');
      } else {
        countEl.classList.add('hidden-count');
      }
    });
  }

  function setButtonState(button, text, disabled) {
    if (!button) return;

    var productButtonLabel = button.querySelector('[id^="addToCartText-"]');
    if (productButtonLabel) {
      productButtonLabel.textContent = text;
    } else {
      button.textContent = text;
    }
    button.disabled = disabled;
  }

  function beginCartAdd() {
    activeCartAdds += 1;
  }

  function endCartAdd() {
    activeCartAdds = Math.max(0, activeCartAdds - 1);
    if (activeCartAdds || !cartAddIdleCallbacks.length) return;

    var callbacks = cartAddIdleCallbacks.slice();
    cartAddIdleCallbacks.length = 0;
    callbacks.forEach(function(callback) { callback(); });
  }

  function whenCartAddsIdle() {
    if (!activeCartAdds) return Promise.resolve();
    return new Promise(function(resolve) { cartAddIdleCallbacks.push(resolve); });
  }

  function resetRelatedCarouselCard(card, releaseFocus) {
    if (!card || !card.classList.contains('product-related-carousel__card')) return;

    var form = card.querySelector('[data-custom-add-to-cart-box]');
    if (form) {
      form._interactionGeneration = (form._interactionGeneration || 0) + 1;
      clearTimeout(form.customQuantityPopoverTimer);
      clearTimeout(form.customAddConfirmationTimer);
      form.removeAttribute('aria-busy');
      form.classList.remove('is-quantity-popover-visible', 'is-quantity-interacted', 'has-added-confirmation');

      var quantity = form.querySelector('input[name="quantity"]');
      if (quantity) quantity.value = quantity.getAttribute('min') || '1';

      var button = form.querySelector('[data-custom-add-to-cart-button]');
      if (button) setButtonState(button, button.getAttribute('data-idle-label') || 'Add', false);
    }

    card.classList.remove('has-open-quantity', 'has-add-confirmation', CAROUSEL_POINTER_FOCUS_CLASS);

    var active = document.activeElement;
    if (releaseFocus && active && card.contains(active) && active.matches('[data-custom-add-to-cart-button], input[name="quantity"]') && active.blur) {
      active.blur();
    }
  }

  function resetCartToastSource(toast, releaseFocus) {
    var returnFocusElement = toast && toast._cartReturnFocusElement;
    var card = returnFocusElement && returnFocusElement.closest
      ? returnFocusElement.closest('.product-related-carousel__card')
      : null;
    resetRelatedCarouselCard(card, releaseFocus);
    if (toast) toast._cartReturnFocusElement = null;
    return { card: card, returnFocusElement: returnFocusElement };
  }

  function resetAllRelatedCarouselCards(releaseFocus) {
    document.querySelectorAll('.product-related-carousel__card').forEach(function(card) {
      resetRelatedCarouselCard(card, releaseFocus);
    });
  }

  function resetCarouselReturnState(returnFocusElement, pointerReturn) {
    var card = returnFocusElement && returnFocusElement.closest
      ? returnFocusElement.closest('.product-related-carousel__card')
      : null;
    if (!card) return;

    resetRelatedCarouselCard(card, false);
    card.classList.toggle(CAROUSEL_POINTER_FOCUS_CLASS, Boolean(pointerReturn));
  }

  document.addEventListener('pointerdown', function() {
    lastInputWasKeyboard = false;
  }, true);

  document.addEventListener('keydown', function(event) {
    if (event.key === 'Shift' || event.key === 'Control' || event.key === 'Alt' || event.key === 'Meta') return;
    lastInputWasKeyboard = true;
    document.querySelectorAll('.product-related-carousel__card.' + CAROUSEL_POINTER_FOCUS_CLASS).forEach(function(card) {
      card.classList.remove(CAROUSEL_POINTER_FOCUS_CLASS);
    });
  }, true);

  document.addEventListener('cart:drawer:closed', function(event) {
    var returnFocusElement = event.detail && event.detail.returnFocusElement;
    var returnedCard = returnFocusElement && returnFocusElement.closest
      ? returnFocusElement.closest('.product-related-carousel__card')
      : null;
    resetCarouselReturnState(returnedCard ? returnFocusElement : cartDrawerCarouselReturnFocusElement, !lastInputWasKeyboard);
    cartDrawerCarouselReturnFocusElement = null;
  });

  document.addEventListener('quick-view:closed', function(event) {
    var detail = event.detail || {};
    resetCarouselReturnState(detail.returnFocusElement, detail.pointerReturn);
  });

  function showQuantityPopover(form) {
    if (!form || !form.querySelector('[data-quantity-popover]')) return;

    form.classList.add('is-quantity-popover-visible');
    var card = form.closest('[data-product-card]');
    if (card) card.classList.add('has-open-quantity');
    clearTimeout(form.customQuantityPopoverTimer);

    var popover = form.querySelector('[data-quantity-popover]');
    var isInteracting = popover.matches(':hover') || popover.contains(document.activeElement) || (card && card.matches(':hover'));

    if (!isInteracting) scheduleQuantityPopoverClose(form);
  }

  function scheduleQuantityPopoverClose(form) {
    if (!form) return;

    clearTimeout(form.customQuantityPopoverTimer);
    form.customQuantityPopoverTimer = setTimeout(function() {
      form.classList.remove('is-quantity-popover-visible');
      var card = form.closest('[data-product-card]');
      if (card) card.classList.remove('has-open-quantity');
    }, 2800);
  }

  document.addEventListener('pointerover', function(event) {
    var popover = event.target.closest('[data-quantity-popover]');
    if (!popover) return;

    var form = popover.closest('[data-custom-add-to-cart-box]');
    if (form) clearTimeout(form.customQuantityPopoverTimer);
  });

  document.addEventListener('pointerout', function(event) {
    var popover = event.target.closest('[data-quantity-popover]');
    if (!popover || (event.relatedTarget && popover.contains(event.relatedTarget))) return;

    var form = popover.closest('[data-custom-add-to-cart-box]');
    if (form && !form.classList.contains('is-quantity-interacted')) {
      scheduleQuantityPopoverClose(form);
    }
  });

  document.addEventListener('focusin', function(event) {
    var popover = event.target.closest('[data-quantity-popover]');
    if (!popover) return;

    var form = popover.closest('[data-custom-add-to-cart-box]');
    if (form) {
      form.classList.add('is-quantity-interacted');
      clearTimeout(form.customQuantityPopoverTimer);
    }
  });

  document.addEventListener('focusout', function(event) {
    var popover = event.target.closest('[data-quantity-popover]');
    if (!popover || (event.relatedTarget && popover.contains(event.relatedTarget))) return;

    var form = popover.closest('[data-custom-add-to-cart-box]');
    if (form && !form.classList.contains('is-quantity-interacted')) {
      scheduleQuantityPopoverClose(form);
    }
  });

  document.addEventListener('pointerover', function(event) {
    var card = event.target.closest('[data-product-card]');
    if (!card || (event.relatedTarget && card.contains(event.relatedTarget))) return;
    var form = card.querySelector('[data-custom-add-to-cart-box].is-quantity-popover-visible');
    if (form) clearTimeout(form.customQuantityPopoverTimer);
    refreshProductCardCartQuantities();
  });

  document.addEventListener('pointerout', function(event) {
    var card = event.target.closest('[data-product-card]');
    if (!card || (event.relatedTarget && card.contains(event.relatedTarget))) return;

    var form = card.querySelector('[data-custom-add-to-cart-box].is-quantity-popover-visible');
    if (!form || form.classList.contains('is-quantity-interacted')) return;
    if (card.contains(document.activeElement) && document.activeElement.blur) {
      document.activeElement.blur();
    }
    scheduleQuantityPopoverClose(form);
  });

  function updateProductCardCartQuantities(cart) {
    var quantities = {};

    (cart.items || []).forEach(function(item) {
      quantities[String(item.variant_id)] = (quantities[String(item.variant_id)] || 0) + item.quantity;
    });

    document.querySelectorAll('[data-custom-add-to-cart-box]').forEach(function(form) {
      var indicator = form.querySelector('[data-cart-quantity-indicator]');
      if (!indicator) return;

      var quantity = quantities[form.getAttribute('data-variant-id')] || 0;
      indicator.textContent = quantity + ' in cart';
      indicator.hidden = quantity === 0;
    });
  }

  function refreshProductCardCartQuantities() {
    if (!document.querySelector('[data-custom-add-to-cart-box]')) return;

    if (cartRefreshPromise) return cartRefreshPromise;

    cartRefreshPromise = fetch(themeAjaxRoute('cartUrl', '/cart.js'), { headers: { 'Accept': 'application/json' } })
      .then(function(response) {
        if (!response.ok) throw new Error('Cart fetch failed');
        return response.json();
      })
      .then(updateProductCardCartQuantities)
      .catch(function() {})
      .then(function() { cartRefreshPromise = null; });

    return cartRefreshPromise;
  }

  window.addEventListener('pagehide', function() {
    resetAllRelatedCarouselCards(false);
  });

  window.addEventListener('pageshow', function(event) {
    resetAllRelatedCarouselCards(Boolean(event.persisted));
    document.querySelectorAll('.is-quantity-popover-visible').forEach(function(form) {
      form.classList.remove('is-quantity-popover-visible');
      var card = form.closest('[data-product-card]');
      if (card) card.classList.remove('has-open-quantity');
    });
    refreshProductCardCartQuantities();
  });

  window.addEventListener('focus', refreshProductCardCartQuantities);
  document.addEventListener('visibilitychange', function() {
    if (!document.hidden) refreshProductCardCartQuantities();
  });
  document.addEventListener('cart:updated', refreshProductCardCartQuantities);
  document.addEventListener('cart:change', refreshProductCardCartQuantities);

  function showCustomCartToast(item, quantity, returnFocusElement) {
    var toast = document.querySelector('[data-cart-toast]');
    if (!toast) return;
    if (toast._cartReturnFocusElement && toast._cartReturnFocusElement !== returnFocusElement) {
      resetCartToastSource(toast, false);
    }
    toast._cartReturnFocusElement = returnFocusElement || null;

    var heading = toast.querySelector('[data-cart-toast-heading-text]');
    var title = toast.querySelector('[data-cart-toast-title]');
    var meta = toast.querySelector('[data-cart-toast-meta]');
    var image = toast.querySelector('[data-cart-toast-image]');

    var productTitle = item.product_title || item.title || 'Item added';

    if (heading) {
      heading.textContent = quantity + ' item' + (quantity > 1 ? 's' : '') + ' added to your cart';
    }

    if (title) {
      title.textContent = productTitle + ' × ' + quantity;
    }

    if (meta) {
      meta.textContent = 'Added to cart';
    }

    var addedImage = item.image ||
      (item.featured_image && (item.featured_image.url || item.featured_image.src)) ||
      (item.product && item.product.featured_image);

    if (!addedImage && document.body.classList.contains('template-product')) {
      var visibleProductImage = document.querySelector('#ProductSection .lazyload__image-wrapper:not(.hide) img');
      if (visibleProductImage) {
        addedImage = visibleProductImage.currentSrc || visibleProductImage.src || visibleProductImage.getAttribute('data-src');
      }
    }

    if (typeof addedImage === 'string' && addedImage.indexOf('{width}') !== -1) {
      addedImage = addedImage.replace('{width}', '360');
    }

    if (image && addedImage) {
      image.src = addedImage;
      image.alt = productTitle;
      image.style.display = '';
    } else if (image) {
      image.removeAttribute('src');
      image.alt = '';
      image.style.display = 'none';
    }

    toast.classList.add(TOAST_VISIBLE_CLASS);
    toast.setAttribute('aria-hidden', 'false');

    clearTimeout(window.customCartToastTimer);

    window.customCartToastTimer = setTimeout(function() {
      resetCartToastSource(toast, false);
      toast.classList.remove(TOAST_VISIBLE_CLASS);
      toast.setAttribute('aria-hidden', 'true');
    }, 4000);
  }

  document.addEventListener('click', function(event) {
    var close = event.target.closest('[data-cart-toast-close]');
    if (!close) return;

    var toast = close.closest('[data-cart-toast]');
    if (!toast) return;

    clearTimeout(window.customCartToastTimer);
    resetCartToastSource(toast, false);
    toast.classList.remove(TOAST_VISIBLE_CLASS);
    toast.setAttribute('aria-hidden', 'true');
  });

  document.addEventListener('click', function(event) {
    var openLink = event.target.closest('[data-cart-toast-open]');
    if (!openLink) return;

    var toast = openLink.closest('[data-cart-toast]');
    if (!toast) return;

    var toastSource = resetCartToastSource(toast, false);
    var returnFocusElement = toastSource.returnFocusElement;

    if (typeof ajaxifyShopify !== 'undefined' && typeof ajaxifyShopify.openCart === 'function') {
      event.preventDefault();
      cartDrawerCarouselReturnFocusElement = returnFocusElement;
      ajaxifyShopify.openCart(returnFocusElement);
    }

    clearTimeout(window.customCartToastTimer);
    toast.classList.remove(TOAST_VISIBLE_CLASS);
    toast.setAttribute('aria-hidden', 'true');
  });

  function setCartClearBusy(button, busy) {
    var drawer = button && button.closest('#ajaxifyDrawer');
    var content = drawer && drawer.querySelector('#ajaxifyCart');
    if (button) {
      button.disabled = busy;
      if (busy) button.textContent = 'Emptying\u2026';
    }
    if (drawer) drawer.classList.toggle('is-clearing-cart', busy);
    if (content) {
      content.toggleAttribute('inert', busy);
      if (busy) content.setAttribute('aria-busy', 'true');
      else content.removeAttribute('aria-busy');
    }
  }

  function clearPendingDrawerQuantityUpdates() {
    if (!window.jQuery) return;
    window.jQuery('#ajaxifyDrawer .ajaxifyCart--num').each(function() {
      var input = window.jQuery(this);
      clearTimeout(input.data('cartUpdateTimer'));
      input.removeData('cartUpdateTimer');
    });
  }

  function syncConfirmedCart(cart) {
    updateCartCount(cart.item_count);
    updateProductCardCartQuantities(cart);
    if (typeof ajaxifyShopify !== 'undefined' && typeof ajaxifyShopify.refreshCart === 'function') {
      ajaxifyShopify.refreshCart(cart);
    }
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
  }

  function fetchCurrentCart() {
    return fetch(themeAjaxRoute('cartUrl', '/cart.js'), {
      headers: { 'Accept': 'application/json' }
    }).then(function(response) {
      if (!response.ok) throw new Error('Cart fetch failed');
      return response.json();
    });
  }

  document.addEventListener('click', function(event) {
    if (!cartClearPromise) return;
    var mutationControl = event.target.closest('#ajaxifyDrawer [data-clear-cart], #ajaxifyDrawer .ajaxifyCart--qty-adjuster, #ajaxifyDrawer .ajaxifyCart--remove, #ajaxifyDrawer [name="checkout"]');
    if (!mutationControl) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);

  document.addEventListener('submit', function(event) {
    if (!cartClearPromise || !event.target.closest('#ajaxifyDrawer')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);

  document.addEventListener('click', function(event) {
    var clearButton = event.target.closest('[data-clear-cart]');
    if (!clearButton || clearButton.disabled || cartClearPromise) return;

    event.preventDefault();
    clearPendingDrawerQuantityUpdates();
    setCartClearBusy(clearButton, true);

    var themeCartIdle = typeof ajaxifyShopify !== 'undefined' && typeof ajaxifyShopify.whenCartIdle === 'function'
      ? ajaxifyShopify.whenCartIdle()
      : Promise.resolve();

    cartClearPromise = Promise.all([themeCartIdle, whenCartAddsIdle()])
      .then(function() {
        return fetch(themeAjaxRoute('cartClearUrl', '/cart/clear.js'), {
          method: 'POST',
          headers: { 'Accept': 'application/json' }
        });
      })
      .then(function(response) {
        if (!response.ok) throw new Error('Cart clear failed');
        return response.json();
      })
      .then(function(cart) {
        if (!cart || cart.item_count !== 0) throw new Error('Cart was not cleared');
        return { cart: cart, failed: false };
      })
      .catch(function() {
        return fetchCurrentCart()
          .then(function(cart) { return { cart: cart, failed: cart.item_count > 0 }; })
          .catch(function() { return { cart: null, failed: true }; });
      })
      .then(function(result) {
        if (result.cart) syncConfirmedCart(result.cart);

        cartClearPromise = null;
        setCartClearBusy(clearButton, false);

        var currentButton = document.querySelector('#ajaxifyDrawer [data-clear-cart]') || clearButton;
        if (result.failed && (!result.cart || result.cart.item_count > 0)) {
          currentButton.style.display = '';
          currentButton.disabled = false;
          currentButton.textContent = 'Couldn\u2019t empty cart \u2014 retry';
        }
      });
  });

  /* Quantity buttons */
  document.addEventListener('click', function(event) {
    var minus = event.target.closest('[data-qty-minus]');
    var plus = event.target.closest('[data-qty-plus]');

    if (!minus && !plus) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    var qty = event.target.closest('.custom-product-qty, [data-quick-view-quantity]');
    var input = qty ? qty.querySelector('input[name="quantity"], [data-smart-search-quantity]') : null;

    if (!input) return;

    var value = parseInt(input.value, 10) || 1;

    input.value = minus ? Math.max(1, value - 1) : value + 1;
    resizeQuantityInput(input);

    var form = event.target.closest('[data-custom-add-to-cart-box]');
    if (form) form.classList.add('is-quantity-interacted');
    showQuantityPopover(form);
  }, true);

  function handleAddToCart(event, form) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    if (cartClearPromise || form.getAttribute('aria-busy') === 'true') return;

    var variantSelect = form.querySelector('select[name="id"]');
    var variantInput = form.querySelector('input[name="id"]');
    var variantId = variantSelect ? variantSelect.value : (variantInput ? variantInput.value : form.getAttribute('data-variant-id'));
    var quantity = getQuantity(form);
    var button = form.querySelector('[data-custom-add-to-cart-button], button[name="add"], input[name="add"]');
    var idleLabel = button ? button.getAttribute('data-idle-label') || 'Add to Cart' : 'Add to Cart';
    var hasCollectionSelector = !!form.querySelector('[data-quantity-popover]');
    var itemWasAdded = false;
    form._interactionGeneration = form._interactionGeneration || 0;
    var interactionGeneration = form._interactionGeneration;

    if (!variantId || !button || button.disabled) return;

    clearFormError(form);

    document.querySelectorAll('[data-custom-add-to-cart-box].is-quantity-popover-visible').forEach(function(otherForm) {
      if (otherForm === form) return;
      clearTimeout(otherForm.customQuantityPopoverTimer);
      otherForm.classList.remove('is-quantity-popover-visible', 'is-quantity-interacted');
      var otherCard = otherForm.closest('[data-product-card]');
      if (otherCard) otherCard.classList.remove('has-open-quantity');
    });

    if (
      hasCollectionSelector &&
      !form.querySelector('[data-inline-quantity]') &&
      !form.classList.contains('is-quantity-popover-visible')
    ) {
      clearTimeout(form.customAddConfirmationTimer);
      form.classList.remove('has-added-confirmation');
      var existingCard = form.closest('[data-product-card]');
      if (existingCard) existingCard.classList.remove('has-add-confirmation');
      setButtonState(button, idleLabel, false);
      showQuantityPopover(form);
      return;
    }

    form.setAttribute('aria-busy', 'true');
    setButtonState(button, 'Adding\u2026', true);
    beginCartAdd();

    fetch(themeAjaxRoute('cartAddUrl', '/cart/add.js'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: Number(variantId),
        quantity: quantity
      })
    })
      .then(function(response) {
        return response.json().then(function(data) {
          if (!response.ok) {
            var error = new Error('Cart add failed');
            error.customerMessage = data && (data.description || data.message);
            throw error;
          }
          return data;
        });
      })
      .then(function(addedItem) {
        itemWasAdded = true;
        clearThemeCartState();
        if (form._interactionGeneration === interactionGeneration) {
          showCustomCartToast(addedItem, quantity, button);
        }

        return fetch(themeAjaxRoute('cartUrl', '/cart.js'), {
          headers: {
            'Accept': 'application/json'
          }
        });
      })
      .then(function(response) {
        if (!response.ok) throw new Error('Cart fetch failed');
        return response.json();
      })
      .then(function(cart) {
        clearThemeCartState();
        form.removeAttribute('aria-busy');
        updateCartCount(cart.item_count);
        updateProductCardCartQuantities(cart);

        if (typeof ajaxifyShopify !== 'undefined' && typeof ajaxifyShopify.refreshCart === 'function') {
          ajaxifyShopify.refreshCart(cart);
        }

        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));

        clearTimeout(form.customQuantityPopoverTimer);
        form.classList.remove('is-quantity-popover-visible', 'is-quantity-interacted');
        var openCard = form.closest('[data-product-card]');
        if (openCard) openCard.classList.remove('has-open-quantity');
        var card = form.closest('[data-product-card]');
        var interactionWasReset = form._interactionGeneration !== interactionGeneration;

        if (interactionWasReset) {
          form.classList.remove('has-added-confirmation');
          if (card) card.classList.remove('has-add-confirmation');
          setButtonState(button, idleLabel, false);
        } else {
          form.classList.add('has-added-confirmation');
          if (card) card.classList.add('has-add-confirmation');
          setButtonState(button, 'Added ✓', false);

          clearTimeout(form.customAddConfirmationTimer);
          form.customAddConfirmationTimer = setTimeout(function() {
            form.classList.remove('has-added-confirmation');
            if (card) card.classList.remove('has-add-confirmation');
            setButtonState(button, idleLabel, false);
          }, 2500);
        }
        clearThemeCartState();
      })
      .catch(function(error) {
        clearThemeCartState();
        if (form._interactionGeneration !== interactionGeneration) return;
        form.removeAttribute('aria-busy');
        if (itemWasAdded) {
          showFormError(form, 'The item was added, but the cart display could not refresh. Open your cart to confirm it.');
          setButtonState(button, 'Added \u2713', false);
          return;
        }
        showFormError(form, error && error.customerMessage);

        setButtonState(button, 'Try Again', false);

        setTimeout(function() {
          setButtonState(button, idleLabel, false);
        }, 1500);
      })
      .then(endCartAdd, function(error) {
        endCartAdd();
        throw error;
      });
  }

  /*
    Predictive search is itself a form, so its cart action is deliberately a
    non-form group. Handle that button directly in the capture phase to keep it
    from submitting the parent search form or reaching a product-link handler.
  */
  document.addEventListener('click', function(event) {
    var button = event.target.closest('[data-smart-search-cart-action] [data-custom-add-to-cart-button]');
    if (!button) return;

    var action = button.closest('[data-smart-search-cart-action]');
    if (action) handleAddToCart(event, action);
  }, true);

  /* Add to cart form submit */
  document.addEventListener('submit', function(event) {
    var form = event.target.closest('[data-custom-add-to-cart-box], .template-product .product-order-card form[action*="/cart/add"]');
    if (!form) return;

    handleAddToCart(event, form);
  }, true);
})();
